var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "breadcrumb" }, [_c("navbar")], 1),
    _c("div", { staticClass: "Box" }, [
      _c("div", { staticClass: "table_tab" }, [
        _c("div", { staticClass: "inquiry" }, [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "table" },
            [
              _c("matrix-table", {
                attrs: {
                  dataList: _vm.commission.page.list,
                  config: _vm.commission.config,
                },
              }),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "inquiryTab" }, [
          _vm._m(1),
          _c(
            "div",
            { staticClass: "table" },
            [
              _c("matrix-table", {
                attrs: {
                  dataList: _vm.manage.page.list,
                  config: _vm.manage.config,
                },
                on: { receiveData: _vm.handlerEmitFanStr },
              }),
              _c("div", { staticClass: "page" }, [
                _c(
                  "div",
                  { staticClass: "block" },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.manage.page.pageNo,
                        "page-size": _vm.manage.page.pageSize,
                        "page-sizes": [3, 5, 10, 20, 50],
                        layout: "total, sizes,prev, pager, next",
                        total: _vm.manage.page.totalNum,
                      },
                      on: {
                        "size-change": _vm.onSizeChange,
                        "current-change": _vm.onCurrentChange,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "headerbox" }, [
      _c("div", { staticClass: "header" }, [_vm._v(" 积分统计 ")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "inquiryTab_header" }, [
      _c("div", { staticClass: "tabTitle" }, [_vm._v("积分查询")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }